import Skeleton from '@mui/material/Skeleton';

const LargeSquare = () => {
  return (
    <Skeleton variant="circular" width={60} height={60} />
  )
}

export default LargeSquare